(ns practitest.frontend.find-and-replace-modal.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::find-and-replace-modal
  (fn [db [_]]
    (:find-and-replace-modal db)))

(re-frame/reg-sub
  ::open?
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (boolean (:open? modal))))

(re-frame/reg-sub
  ::entity
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:entity modal)))

(re-frame/reg-sub
  ::selection
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:selection modal)))

(re-frame/reg-sub
  ::state-key
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:state-key modal)))

(re-frame/reg-sub
  ::fields
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:fields modal)))

(re-frame/reg-sub
  ::finding?
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (boolean (:finding? modal))))

(re-frame/reg-sub
  ::submitting?
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (boolean (:submitting? modal))))

(re-frame/reg-sub
  ::find-val
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:find-val modal)))

(re-frame/reg-sub
  ::replace-val
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:replace-val modal)))

(re-frame/reg-sub
  ::selected-fields
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:selected-fields modal)))

;; :idle - no results yet; :found - last Find matched at least one entity.
(re-frame/reg-sub
  ::stage
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:stage modal)))

(re-frame/reg-sub
  ::message
  :<- [::find-and-replace-modal]
  (fn [modal [_]]
    (:message modal)))

;; find-val 2-254 chars, replace-val 0-254 chars, at least one field selected.
(re-frame/reg-sub
  ::input-invalid?
  :<- [::find-val]
  :<- [::replace-val]
  :<- [::selected-fields]
  (fn [[find-val replace-val selected-fields] [_]]
    (or (not (<= 2 (count find-val) 254))
        (not (<= 0 (count replace-val) 254))
        (empty? selected-fields))))
